export const statusColorMap = {
  'In Progress': 'rgba(245, 133, 0, 1)',
  Submitted: 'rgba(4, 184, 108, 1)',
  Incomplete: 'rgba(4, 184, 108, 1)',
};
